//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import * as $ from 'jquery';

import {
  IBasicCuralateSession,
  ICuralateSession,
} from 'app/basic-session/ICuralateSession';
import GaApi from 'app/initialization/ga/ga-api';
import { Logger } from 'app/logger/logger';

export interface ICrl8Object {
  session?: ICuralateSession; // This is actually ICuralateSession | IBasicCuralateSession
  sessionPromise: JQueryDeferred<IBasicCuralateSession>;
  userSessionPromise: JQueryDeferred<ICuralateSession>;
  logger: Logger;
  isAuthedSession: () => boolean;
  isMediaTrackingEnabled: boolean;
  toggleQueryDevtools?: () => void; // Used to toggle React Query Devtools
  queryDevtoolsAlreadyEnabled?: boolean; // Used to prevent multiple renders of devtools
}

interface ICURALATE {
  misc: {
    renderToReadableNumber: (o: unknown, val: number) => string;
    renderToReadableDecimal: (o: unknown, val: number) => string;
    Components: {
      changeClient: (clientId: number) => void;
    };
  };
  tracking: typeof GaApi;
}

export function isAuthedSession(
  session: ICuralateSession | IBasicCuralateSession | undefined,
): session is ICuralateSession {
  return !!(session && 'client' in session && 'user' in session);
}

const windowRef = window as unknown as {
  crl8?: Partial<ICrl8Object>;
  CURALATE: ICURALATE;
};

export const crl8: ICrl8Object = (() => {
  const crl8init: Partial<ICrl8Object> = (windowRef.crl8 =
    windowRef.crl8 ?? {});
  crl8init.sessionPromise = windowRef.crl8.sessionPromise ?? $.Deferred();
  crl8init.userSessionPromise =
    windowRef.crl8.userSessionPromise ?? $.Deferred();
  crl8init.isAuthedSession = () => isAuthedSession(crl8.session);
  crl8init.isMediaTrackingEnabled = false;
  return crl8init as ICrl8Object;
})();

windowRef.CURALATE = windowRef.CURALATE ?? ({} as ICURALATE);
export const CURALATE = windowRef.CURALATE;
